import ProfileAvatar from './ProfileAvatar'

export default ProfileAvatar
